import { appPanesConfiguration } from '../config/appPanesConfiguration';
import { type AppPaneConfig } from '../types/AppPaneConfig';

/**
 * Gets the configuration for a specific paneId
 * @param paneId The full paneId to find
 * @returns the configuration if found, undefined otherwise
 */
export default function getConfigurationByPaneId(paneId: string): AppPaneConfig | undefined {
    return appPanesConfiguration.find(config => config.paneId === paneId);
}
